import { disponibile, inPrenotazione, prenotato, vuoto, disabili } from './colors';

export function getColorFromStatus(seat) {
  switch (seat.stato) {
    case 'Disponibile':
      return disponibile;
    case 'In prenotazione':
        return inPrenotazione;
    case 'Prenotato':
      return prenotato;
    case 'Disabili':
      return disabili;
    default:
      return vuoto;
  }
}

export function getHoverStyle(seat) {
  if (seat.stato === 'Disponibile' || seat.stato === 'Disabili') {
    return { bg: 'gray.400' };
  }else{
    return { bg: getColorFromStatus(seat) };
  }
}